// extracted by mini-css-extract-plugin
export default {"priceDetails":"OrderDetails_priceDetails__yVxoH"};